import { baseUrl } from "../constants/api";
import { SignInFromCookieType, SignInType } from "../types/auth";
import { ApiResponse } from "../types/api";
import { FetchResponse } from "../types/fetch";
import { fetchWithAuthJson } from "../utils/fetch";

declare global {
  interface Window {
    gtag: any;
  }
}

export const getRequest = async (endpoint: string) => {
  try {
    const response = await fetchWithAuthJson(`${baseUrl}${endpoint}`, {
      method: "GET",
    });
    return response.data;
  } catch (error) {
    console.warn("There was an error whilst fetching data", error);
    throw error;
  }
};

export const ssoLoginRequest = async (endpoint: string, body: SignInType): Promise<FetchResponse<any>> => {
  try {
    const response = await fetchWithAuthJson(endpoint, {
      method: "POST",
      skipAuth: true,
      skip401Retry: true,
      body: JSON.stringify(body),
    });

    if (response.statusText === "Success" || (response.status === 200 && response.data && response.data.user)) {
      const user = response.data.user || response.data.data?.user;
      if (user) {
        // Use gtag to set user details
        if (window.gtag) {
          window.gtag("event", "log_in", {
            user_id: user.UserId, // Set user_id variable
            user_email: user.Email, // Set user_email variable
            role: user.Roles?.join(",") || "", // Set role, assuming it's an array
          });
        }
      }
    }

    return response;
  } catch (error) {
    throw error;
  }
};

export const ssoLoginFromCookieRequest = async (endpoint: string, body: SignInFromCookieType): Promise<FetchResponse<any>> => {
  try {
    const response = await fetchWithAuthJson(endpoint, {
      method: "POST",
      skipAuth: true,
      skip401Retry: true,
      body: JSON.stringify(body),
    });

    if (response.statusText === "Success" || (response.status === 200 && response.data && response.data.user)) {
      const user = response.data.user || response.data.data?.user;
      if (user) {
        // Use gtag to set user details
        if (window.gtag) {
          window.gtag("event", "log_in", {
            user_id: user.UserId, // Set user_id variable
            user_email: user.Email, // Set user_email variable
            role: user.Roles?.join(",") || "", // Set role, assuming it's an array
          });
        }
      }
    }

    return response;
  } catch (error) {
    throw error;
  }
};

export const postCookieRequest = async (endpoint: string, body_data: object): Promise<ApiResponse> => {
  try {
    // fetchWithAuth automatically adds Authorization header
    const response = await fetchWithAuthJson<ApiResponse>(`${baseUrl}${endpoint}`, {
      method: "POST",
      body: JSON.stringify(body_data),
    });

    if (response.status === 200 && response.data) {
      if (response.data.status === "error") {
        throw new Error(response.data.message);
      }
      return response.data;
    }

    throw new Error("Request failed");
  } catch (error) {
    throw error;
  }
};

export const logoutRequest = async (endpoint: string): Promise<string> => {
  try {
    // fetchWithAuth automatically adds Authorization header
    const response = await fetchWithAuthJson<string>(`${baseUrl}${endpoint}`, {
      method: "GET",
    });

    if (response.status === 200 && response.data) {
      if (response.data === "error") {
        throw new Error(response.data);
      }
      return response.data;
    }

    throw new Error("Request failed");
  } catch (error) {
    throw error;
  }
};
